import { agentV2Epic as epic } from './epics'
import { agentV2Reducer as reducer } from './reducer'

export const agentV2Epic = epic
export const agentV2Reducer = reducer
